import React from "react";
import Modal from "~/components/modal/Modal";
import "~/css/Button.css";
import "~/css/ReceptionSettingsErrorModal.css";

interface ReceptionSettingsErrorModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  body: string;
  confirmText: string;
}

/**
 * iFace のエラーコードおよびエラーメッセージを表示するためのモーダルコンポーネント。
 * `body` には改行を含むテキストを渡すことで、改行付きのエラー内容を表示できる。
 *
 * @param props.show モーダルを表示するかどうかのフラグ。`true` で表示、`false` で非表示。
 * @param props.onClose モーダルを閉じる際に呼び出されるコールバック関数。
 * @param props.title モーダルヘッダーに表示するタイトル（エラーコードや概要など）。
 * @param props.body モーダル本文に表示するエラーメッセージ。改行を含めて渡すことができる。
 * @param props.confirmText フッターの確定ボタンに表示するラベル文字列。
 */
const ReceptionSettingsErrorModal: React.FC<ReceptionSettingsErrorModalProps> = ({
  show,
  onClose,
  title,
  body,
  confirmText,
}) => {
  return (
    <Modal isOpen={show} onClose={onClose} title={title} width={600} height={360}>
      <div className="iface-error-modal-body">{body}</div>
      <div className="modal-footer">
        <button type="button" className="button-1" onClick={onClose}>
          {confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ReceptionSettingsErrorModal;
